module.exports = new __parcel__URL__("grand-theft-auto-vice-city-stories.8b3ac3b7.jpg").toString();